/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaConstFloatModel, isSchemaConstFloatModel } from "@adapptio/lib-blueprint";
import { INSPECTOR_NODE_TYPE, TInspectorNode } from "../InspectorNodeTypes";
import { IInspectorControl_Float, INSPECTOR_CONTROL_TYPE } from "../controls";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";
import { getParentComponentName } from "../utils";

export function constFloatMapper(model: ISchemaConstFloatModel): TInspectorNode {
	if (!isSchemaConstFloatModel(model)) {
		return;
	}

	const control: IInspectorControl_Float = {
		key: String(model.nodeId),
		type: INSPECTOR_CONTROL_TYPE.FLOAT,
		model
	};

	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: `${model.nodeId}`,
		label: model.schema.opts.label,
		tooltip: model.schema.opts.description,
		options: model.schema.opts["options"],
		default: model.schema.opts.default || null,
		required: model.schema.opts.constraints?.required || false,
		referenceData: getParentComponentName(model),
		descriptor: mapperDescriptor(model.schema),
		examples: mapperExamples(model.schema),
		deps: [ model ],
		controls: [ control ],
		children: []
	};
}
